define('ProductDetailsCompatibility.EntryPoint', [
  'ProductDetails.Compatibility.View'
], function (
  CompatibilityView
) {
  'use strict';

  return {
    mountToApp: function mountToApp(container) {
      var layout = container.getComponent('Layout');
      if (layout) {
        layout.registerView('ProductDetails.Compatibility', function () {
          var pdp = container.getComponent('PDP');
          var model = pdp ? pdp.getItemInfo() : null;
          return new CompatibilityView({ model: model });
        });
      }
    }
  };
});
